import React, { useEffect } from "react";
import * as Constants from "../../../../../consts/Constants.js";
import Style from "../../../../../styles/js/StyleCallList.js";
import InputPreview from "./input-preview";
import CircularProgress from '@mui/material/CircularProgress';

import service from "../../../../../plas/services/calls/service";
import { Configuration } from '../../../../../plas/services/calls/models';

export default function ConfigurationPreview( { configurationId } ) {

  const style = Style();

  const [loading, setLoading] = React.useState(true);
  const [configuration, setConfiguration] = React.useState(null);

  useEffect(() => {
    getForm();
  }, []);

  const getForm = () => {
    service.api.configurations.get(configurationId, (response) => {
      if (response.result != null) {
        let data = response.result
        setConfiguration(new Configuration(data));
      }
      setLoading(false);
    });
  }

  return (
    <div className={style.box} >
      { loading ?
        (
          <div style={{color:Constants.COLOR_PRIMARY}}>
            <CircularProgress color="inherit" />
          </div>
        ) : (
          <div className={style.box}>
            { configuration.inputs.map((input) => (
                <InputPreview input={ input } />
              )
            )}
          </div>
        )
      }
    </div>
  );
}
